import { Drawer } from '@base-ui/react/drawer';
import { createGlobalStyle, css, styled } from 'styled-components';

const glass = css`
  background: rgb(238 233 217 / 0.92);
  border-top: 1px solid rgb(33 31 24 / 0.3);
  box-shadow: 0 22px 60px rgb(21 28 18 / 0.24);
  backdrop-filter: blur(16px) saturate(0.82);
`;

export const GlobalStyle = createGlobalStyle`
  :root {
    color: #211f18;
    background: #e9e4d3;
    font-family: 'DM Sans', sans-serif;
    font-synthesis: none;
    --paper: #eee9d9;
    --ink: #211f18;
    --ember: #ff6a2a;
    --moss: #314738;
  }

  * { box-sizing: border-box; }
  html, body, #app { width: 100%; height: 100%; min-height: 100%; margin: 0; overflow: hidden; }
  body { background: var(--paper); overscroll-behavior: none; }
  button { font: inherit; }

  .maplibregl-ctrl-attrib { background: rgb(238 233 217 / .82) !important; font-size: 9px; }

  .trail-photo-marker {
    position: absolute;
    width: 1.8rem;
    height: 1.8rem;
    padding: 0;
    overflow: visible;
    border: 0;
    background: transparent;
    cursor: pointer;
    opacity: .84 !important;
    transition: opacity 180ms ease;
  }
  .trail-photo-marker-frame {
    position: absolute;
    inset: 0;
    z-index: 3;
    display: block;
    overflow: hidden;
    border: 2px solid rgb(238 233 217 / .9);
    border-radius: .18rem;
    background: #d9d2bc;
    box-shadow: 0 5px 15px rgb(11 15 11 / .38);
    transform-origin: center bottom;
    transition:
      border-color 180ms ease,
      box-shadow 180ms ease,
      transform 240ms cubic-bezier(.16, 1, .3, 1);
  }
  .trail-photo-marker-frame[data-stack-index='1'] {
    z-index: 2;
    transform: translate(3px, -3px);
  }
  .trail-photo-marker-frame[data-stack-index='2'] {
    z-index: 1;
    transform: translate(-3px, -6px);
  }
  .trail-photo-marker img { display: block; width: 100%; height: 100%; object-fit: cover; }
  .trail-photo-marker-photo-count {
    position: absolute;
    top: -7px;
    right: -7px;
    z-index: 6;
    display: grid;
    min-width: 17px;
    height: 17px;
    padding: 0 3px;
    place-items: center;
    border: 1.5px solid var(--paper);
    border-radius: 999px;
    background: var(--ember);
    box-shadow: 0 2px 8px rgb(11 15 11 / .42);
    color: var(--paper);
    font-size: 9px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -.03em;
    pointer-events: none;
  }
  .trail-photo-marker[data-marker-kind='cluster'] { cursor: zoom-in; }
  .trail-photo-marker:hover,
  .trail-photo-marker:focus-visible { z-index: 4; opacity: 1 !important; }
  .trail-photo-marker[data-selection-active='true'][data-selected='false'] { opacity: .7 !important; }
  .trail-photo-marker[data-selection-active='true'][data-selected='false']:hover,
  .trail-photo-marker[data-selection-active='true'][data-selected='false']:focus-visible { opacity: 1 !important; }
  .trail-photo-marker:hover .trail-photo-marker-frame:first-child,
  .trail-photo-marker:focus-visible .trail-photo-marker-frame:first-child {
    border-color: var(--ember);
    transform: translateY(-1px) scale(1.08);
  }
  .trail-photo-marker:hover .trail-photo-marker-frame[data-stack-index='1'],
  .trail-photo-marker:focus-visible .trail-photo-marker-frame[data-stack-index='1'] {
    transform: translate(5px, -4px);
  }
  .trail-photo-marker:hover .trail-photo-marker-frame[data-stack-index='2'],
  .trail-photo-marker:focus-visible .trail-photo-marker-frame[data-stack-index='2'] {
    transform: translate(-5px, -8px);
  }
  .trail-photo-marker:focus-visible { outline: 2px solid #f4eedc; outline-offset: 7px; }
  .trail-photo-marker[data-selected='true'] { width: 2.55rem; height: 2.55rem; opacity: 1 !important; }
  .trail-photo-marker[data-selected='true'] .trail-photo-marker-frame { border-width: 3px; }
  .trail-photo-marker[data-highlighted='true'] {
    z-index: 8;
    width: 3.15rem;
    height: 3.15rem;
    opacity: 1 !important;
  }
  .trail-photo-marker[data-highlighted='true'] .trail-photo-marker-frame:first-child {
    border-color: var(--ember);
    box-shadow: 0 0 0 4px rgb(255 106 42 / .34), 0 12px 30px rgb(11 15 11 / .58);
  }
  .trail-photo-marker[data-highlighted='true'] img { filter: saturate(1.12) contrast(1.04); }
  .trail-photo-marker[hidden] { display: none; }

  .te-araroa-lightbox {
    --yarl__color_backdrop: rgb(11 15 11 / .97);
    --yarl__color_button: rgb(238 233 217 / .78);
    --yarl__color_button_active: #ff6a2a;
    --yarl__button_filter: drop-shadow(0 2px 10px rgb(0 0 0 / .45));
    --yarl__icon_size: clamp(1.45rem, 2.4vw, 2rem);
    --yarl__navigation_button_padding: 1rem;
    --yarl__toolbar_padding: max(1rem, env(safe-area-inset-top)) max(1rem, env(safe-area-inset-right));
  }
  .te-araroa-lightbox .yarl__slide_image { box-shadow: 0 2rem 6rem rgb(0 0 0 / .35); }
  .te-araroa-lightbox .yarl__navigation_prev,
  .te-araroa-lightbox .yarl__navigation_next,
  .te-araroa-lightbox .yarl__toolbar .yarl__button {
    display: grid;
    width: clamp(2.8rem, 4vw, 3.5rem);
    height: clamp(2.8rem, 4vw, 3.5rem);
    padding: 0;
    place-items: center;
    border: 1px solid rgb(238 233 217 / .34);
    border-radius: 50%;
    background: rgb(11 15 11 / .38);
    transition: color 180ms ease, border-color 180ms ease, background 180ms ease;
  }
  .te-araroa-lightbox .yarl__navigation_prev { left: max(1rem, env(safe-area-inset-left)); }
  .te-araroa-lightbox .yarl__navigation_next { right: max(1rem, env(safe-area-inset-right)); }
  .te-araroa-lightbox .yarl__navigation_prev:hover,
  .te-araroa-lightbox .yarl__navigation_next:hover,
  .te-araroa-lightbox .yarl__toolbar .yarl__button:hover {
    border-color: var(--ember);
    background: rgb(255 106 42 / .16);
  }

  @media (max-width: 700px) {
    .trail-photo-marker { width: 1.65rem; height: 1.65rem; }
    .trail-photo-marker[data-selected='true'] { width: 2.25rem; height: 2.25rem; }
    .trail-photo-marker[data-highlighted='true'] { width: 2.8rem; height: 2.8rem; }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      scroll-behavior: auto !important;
      animation-duration: .01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: .01ms !important;
    }
  }
`;

export const Experience = styled.main<{ $drawerOpen: boolean }>`
  position: fixed;
  inset: 0;
  width: auto;
  height: auto;
  min-height: 100dvh;
  overflow: hidden;

  ${({ $drawerOpen }) =>
    $drawerOpen &&
    css`
      @media (max-width: 700px) {
        & > header,
        & > aside,
        & > nav,
        & > footer {
          opacity: 0;
          pointer-events: none;
        }
      }
    `}
`;

export const MapCanvas = styled.div`
  position: absolute;
  inset: 0;
  background: #d7ddd0;
`;

export const PaperGrain = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.15;
  mix-blend-mode: soft-light;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 180 180' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='4' stitchTiles='stitchTiles'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.3'/%3E%3C/svg%3E");
`;

export const StoryPanel = styled.aside`
  ${glass}
  position: absolute;
  z-index: 3;
  left: clamp(1rem, 4vw, 4rem);
  bottom: clamp(2.7rem, 7vw, 5.5rem);
  width: min(31rem, calc(100vw - 2rem));
  padding: clamp(1rem, 2vw, 1.35rem);
  color: var(--ink);
  transition: opacity 300ms ease;

  @media (max-width: 700px) {
    left: 1rem;
    bottom: calc(2.5rem + env(safe-area-inset-bottom));
    padding: 1rem;
  }
`;

export const OverviewTitle = styled.h1`
  margin: 0;
  font-family: 'Newsreader', serif;
  font-size: clamp(2.15rem, 4vw, 3.2rem);
  font-weight: 300;
  line-height: 0.92;
  letter-spacing: -0.035em;
`;

export const Stats = styled.dl`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin: 1rem 0 0;
  padding-top: 0.9rem;
  border-top: 1px solid rgb(33 31 24 / 0.18);

  div {
    display: flex;
    flex-direction: column-reverse;
    gap: 0.18rem;
  }
  dt {
    font-size: 0.63rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    opacity: 0.64;
  }
  dd {
    margin: 0;
    font-family: 'Newsreader', serif;
    font-size: clamp(1.1rem, 1.7vw, 1.45rem);
    white-space: nowrap;
  }
`;

export const MapTools = styled.nav`
  position: absolute;
  z-index: 4;
  top: clamp(1rem, 3vw, 2.5rem);
  right: clamp(1rem, 3vw, 2.5rem);
  display: flex;
  gap: 0.35rem;
  transition: opacity 300ms ease;

  button {
    appearance: none;
    border: 1px solid rgb(238 233 217 / 0.46);
    padding: 0.62rem 0.85rem;
    color: #f1eddf;
    background: rgb(24 30 22 / 0.58);
    backdrop-filter: blur(12px);
    cursor: pointer;
    transition:
      background 250ms ease,
      transform 250ms ease;
  }
  button:hover,
  button:focus-visible {
    background: rgb(24 30 22 / 0.82);
    transform: translateY(-1px);
  }
  button:focus-visible {
    outline: 2px solid var(--ember);
    outline-offset: 2px;
  }
  button[aria-pressed='true'] {
    border-color: rgb(255 106 42 / 0.76);
  }
  button:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  @media (max-width: 700px) {
    top: calc(0.75rem + env(safe-area-inset-top));
    right: 0.75rem;
    bottom: auto;
    max-width: calc(100vw - 2rem);
    padding: 0;
    button {
      min-height: 2.75rem;
      padding: 0.6rem 0.7rem;
      font-size: 0.72rem;
    }
  }
`;

export const DrawerViewport = styled(Drawer.Viewport)`
  position: fixed;
  z-index: 20;
  inset: 0;
  pointer-events: none;
`;

export const DrawerPopup = styled(Drawer.Popup)`
  ${glass}
  position: absolute;
  top: 0;
  right: 0;
  width: min(28rem, 42vw);
  height: 100%;
  overflow: hidden;
  pointer-events: auto;
  transform: translateX(var(--drawer-swipe-movement-x, 0));
  transition: transform 420ms cubic-bezier(0.16, 1, 0.3, 1);

  &[data-starting-style],
  &[data-ending-style] {
    transform: translateX(100%);
  }

  @media (max-width: 700px) {
    top: auto;
    bottom: 0;
    width: 100%;
    height: min(76dvh, 46rem);
    border-radius: 1.2rem 1.2rem 0 0;
    touch-action: none;
    transform: translateY(calc(var(--drawer-snap-point-offset, 0px) + var(--drawer-swipe-movement-y, 0px)));
    &[data-starting-style],
    &[data-ending-style] {
      transform: translateY(100%);
    }
  }
`;

export const DrawerContent = styled(Drawer.Content)`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 1.5rem 1.5rem calc(7.2rem + env(safe-area-inset-bottom));

  @media (max-width: 700px) {
    padding: 2.1rem 1.15rem calc(6.6rem + env(safe-area-inset-bottom));
    touch-action: auto;
  }
`;

export const DrawerHandle = styled.button`
  display: none;
  @media (max-width: 700px) {
    display: block;
    position: absolute;
    z-index: 7;
    top: 0;
    left: 50%;
    width: 4rem;
    height: 2.75rem;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: grab;
    touch-action: none;
    transform: translateX(-50%);

    &::after {
      content: '';
      position: absolute;
      top: 0.7rem;
      left: 50%;
      width: 2.7rem;
      height: 0.28rem;
      border-radius: 1rem;
      background: rgb(33 31 24 / 0.28);
      transform: translateX(-50%);
    }

    &:focus-visible {
      outline: 2px solid var(--ember);
      outline-offset: -0.35rem;
    }
  }
`;

export const DrawerHeader = styled.header`
  padding-right: 3rem;
  padding-bottom: 1.15rem;
  border-bottom: 1px solid rgb(33 31 24 / 0.17);
`;

export const DrawerDate = styled.p`
  margin: 0 0 0.35rem;
  color: #5d6457;
  font-size: 0.67rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

export const DrawerTitle = styled(Drawer.Title)`
  margin: 0;
  font-family: 'Newsreader', serif;
  font-size: clamp(1.8rem, 3.25vw, 2.55rem);
  font-weight: 400;
  line-height: 0.95;
  letter-spacing: -0.025em;
`;

export const CloseButton = styled(Drawer.Close)`
  position: absolute;
  z-index: 6;
  top: max(1rem, env(safe-area-inset-top));
  right: max(1rem, env(safe-area-inset-right));
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid rgb(33 31 24 / 0.2);
  border-radius: 50%;
  color: var(--ink);
  background: rgb(238 233 217 / 0.94);
  backdrop-filter: blur(12px);
  cursor: pointer;
  &:hover {
    background: rgb(33 31 24 / 0.07);
  }
  &:focus-visible {
    outline: 2px solid var(--ember);
    outline-offset: 2px;
  }
`;

export const DrawerNavigation = styled.nav<{ $collapsed: boolean }>`
  position: absolute;
  z-index: 5;
  right: 0;
  bottom: 0;
  left: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 0.7rem 0.8rem calc(0.7rem + env(safe-area-inset-bottom));
  border-top: 1px solid rgb(33 31 24 / 0.2);
  background: rgb(238 233 217 / 0.96);
  box-shadow: 0 -12px 30px rgb(21 28 18 / 0.1);
  backdrop-filter: blur(16px);
  transition: bottom 420ms cubic-bezier(0.16, 1, 0.3, 1);

  @media (max-width: 700px) {
    bottom: ${({ $collapsed }) => ($collapsed ? 'calc(100% - 13.5rem)' : '0')};
  }
`;

export const DrawerNavigationButton = styled.button<{ $align?: 'right' }>`
  display: grid;
  min-width: 0;
  padding: 0.45rem 0.65rem;
  border: 0;
  border-left: ${({ $align }) => ($align === 'right' ? '1px solid rgb(33 31 24 / 0.18)' : '0')};
  color: var(--ink);
  background: transparent;
  cursor: pointer;
  text-align: ${({ $align }) => ($align === 'right' ? 'right' : 'left')};

  span {
    color: #61645b;
    font-size: 0.58rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
  strong {
    overflow: hidden;
    margin-top: 0.25rem;
    font-family: 'Newsreader', serif;
    font-size: 0.9rem;
    font-weight: 400;
    line-height: 1.1;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:hover:not(:disabled) {
    color: var(--ember);
  }
  &:focus-visible {
    outline: 2px solid var(--ember);
    outline-offset: -2px;
  }
  &:disabled {
    cursor: default;
    opacity: 0.35;
  }
`;

export const DayStats = styled.dl`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1px;
  margin: 1rem 0;
  background: rgb(33 31 24 / 0.14);
  border: 1px solid rgb(33 31 24 / 0.14);

  div {
    padding: 0.85rem;
    background: rgb(238 233 217 / 0.84);
  }
  dt {
    margin-bottom: 0.15rem;
    font-size: 0.62rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    opacity: 0.6;
  }
  dd {
    margin: 0;
    font-family: 'Newsreader', serif;
    font-size: 1.45rem;
  }
`;

export const Section = styled.section`
  padding: 1rem 0;
  border-top: 1px solid rgb(33 31 24 / 0.17);
`;

export const PhotoSection = styled(Section)`
  display: flex;
  flex: 1 0 14rem;
  flex-direction: column;
  min-height: 14rem;
  overflow: hidden;
`;

export const SectionHeading = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.75rem;
  h3 {
    margin: 0;
    font-size: 0.7rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
  }
  span {
    color: #66685f;
    font-size: 0.67rem;
  }
`;

export const ChartFrame = styled.div`
  position: relative;
  height: 11.5rem;
  padding: 0.35rem 0.2rem 0;
  background: rgb(49 71 56 / 0.06);
  border-bottom: 1px solid rgb(33 31 24 / 0.16);
  cursor: crosshair;
  touch-action: pan-y;
  svg {
    display: block;
    width: 100%;
    height: 100%;
    overflow: visible;
  }
`;

export const ChartTooltip = styled.output<{ $x: number; $y: number }>`
  position: absolute;
  z-index: 2;
  left: ${({ $x }) => `${$x}%`};
  top: ${({ $y }) => `${$y}%`};
  min-width: 5.3rem;
  padding: 0.38rem 0.48rem;
  color: #fff8e9;
  background: var(--moss);
  box-shadow: 0 7px 18px rgb(21 28 18 / 0.25);
  font-size: 0.62rem;
  line-height: 1.35;
  text-align: center;
  pointer-events: none;
  transform: translate(-50%, calc(-100% - 0.55rem));
  white-space: nowrap;

  strong {
    display: block;
    font-family: 'Newsreader', serif;
    font-size: 0.92rem;
    font-weight: 500;
  }
`;

export const PhotoGallery = styled.div`
  display: grid;
  flex: 1 1 0;
  align-content: start;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: max-content;
  gap: 0.22rem;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-color: rgb(49 71 56 / 0.48) transparent;
  scrollbar-gutter: stable;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 0.38rem;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgb(49 71 56 / 0.42);
  }

  @media (max-width: 700px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (max-width: 430px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const PhotoGalleryThumb = styled.button`
  position: relative;
  align-self: start;
  width: 100%;
  padding: 0;
  overflow: hidden;
  border: 0;
  background: #d9d2bc;
  cursor: pointer;
  aspect-ratio: 1;
  transition: box-shadow 180ms ease;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: filter 180ms ease;
  }
  &:hover img {
    filter: saturate(1.08) contrast(1.03);
  }
  &:hover {
    z-index: 1;
    box-shadow:
      inset 0 0 0 1px rgb(238 233 217 / 0.72),
      0 4px 12px rgb(21 28 18 / 0.22);
  }
  &:focus-visible {
    outline: 2px solid var(--ember);
    outline-offset: 2px;
  }
`;

export const LightboxMeta = styled.div`
  position: absolute;
  z-index: 2;
  right: max(1rem, env(safe-area-inset-right));
  bottom: max(1rem, env(safe-area-inset-bottom));
  left: max(1rem, env(safe-area-inset-left));
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  pointer-events: none;
  color: #eee9d9;

  > span:first-child {
    font-family: 'Newsreader', serif;
    font-size: clamp(1.05rem, 2vw, 1.35rem);
    font-weight: 300;
  }
`;

export const LightboxCounter = styled.span`
  flex: none;
  color: rgb(238 233 217 / 0.64);
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.13em;
`;

export const EmptyAlbum = styled.div`
  padding: 1.15rem;
  border: 1px dashed rgb(33 31 24 / 0.28);
  color: #62645d;
  font-family: 'Newsreader', serif;
  font-size: 1.05rem;
  text-align: center;
`;
